import React from 'react';
import {Box, Typography, IconButton, Switch, Paper, Tooltip} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

interface DocumentRowProps {
  title: string;
  version: string;
  isVisible: boolean;
  onToggleVisibility: (newValue: boolean) => void;
  onView?: () => void;
}

const DocumentRow: React.FC<DocumentRowProps> = ({
  title,
  version,
  isVisible,
  onToggleVisibility,
  onView,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#f7f7f7',
        borderRadius: 2,
        px: 3,
        py: 2,
      }}
    >
      <Typography fontWeight="bold">
        {title} <Typography component="span">v{version}</Typography>
      </Typography>
      <Box display="flex" alignItems="center" gap={1.5}>
        <IconButton onClick={onView} aria-label="View document">
          <VisibilityIcon />
        </IconButton>
        <Tooltip
          title={
            isVisible
              ? 'Once disabled, the document cannot be re-enabled within OneView.'
              : 'Enable is not supported within OneView.'
          }
        >
          <span>
            <Switch
              checked={isVisible}
              onChange={(e) => onToggleVisibility(e.target.checked)}
              color="primary"
            />
          </span>
        </Tooltip>
      </Box>
    </Paper>
  );
};

export default DocumentRow;
